import React, { useState, useEffect, useMemo } from "react";
import CheckoutDelivery from "../../sections/checkout-delivery-address";
import ChangeMarketModal from "../ChangeMarketModal";
import api from "../../utils/api";
import { getGearsProgressBars, getGearsOrderSummary } from "../../services/gearsCheckoutService";
import { getDeliveryMethods } from "../../services/orderService";
import { useDispatch, useSelector } from "react-redux";
import { deliverySelector, emailSelector } from "../../selectors/gears-checkout";
import { clearBillingInfoAction, clearContactInfoAction, clearShippingInfoAction, setDeliveryAction, setPickupStoreAction } from "../../redux/actions/gears-checkout";
import { useParams } from "react-router-dom";
import { S_LANG, S_MARKET, webStorage } from "../../utils/webStorage";
import { MathUtils } from "../../utils";
import "./style.scss";
import CheckoutErrorView from "../../sections/checkout-error-view/index";
import { getApiErrors, isLoggedIn, getMarketCountry } from "../../services/siteService";
import { getCart } from "../../services/cartService";
import _ from "lodash";
import { isEmptyObject } from "../../utils/siteUtils";
import { getAddressList } from "../../services/checkoutService";
import { selectUserState, staffInfoSelector } from "../../selectors/application";
import { InstantCode, PickupInStoreCode } from "../../utils/lynkco-constants";

const DeliveryPage = ({ page, fields, rendering }) => {
  /*Redux start*/
  const staffInfo = useSelector(staffInfoSelector);
  /*Redux end*/
  const inStore = useMemo(() => {
    return !!staffInfo;
  }, [staffInfo]);
  const {
    fields: { gearsPaymentLink }
  } = page;
  const {
    billingCheckbox,
    billingFormLabels,
    // billingHeadingBody,
    // billingHeadingType,
    changeMarketButtonText,
    emailTopBody,
    countryLabel,
    deliveryheading,
    freeText,
    headingBody,
    headingType,
    progressBar,
    selectedBar,
    // shippingFormLabels,
    submitButtonText,
    submiticon,
    summaryItem,
    acceptButton,
    rejectLink,
    modelHeadingType,
    modelHeadingBody,
    modelBody,
    countryImput,
    newAddressLabel,
    shippingInfo,
    billingInfo,
    storeInfo
  } = fields;
  const params = useParams();
  const lang = webStorage.get(S_LANG);
  const [deliveryMethods, setDeliveryMethods] = useState([]);
  const [selectedDelivery, setSelectedDelivery] = useState(null);
  const [loadingSummary, setLoadingSummary] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState(null);
  const [currentMarket, setCurrentMarket] = useState(null);
  const [markets, setMarkets] = useState([]);
  const [orderSummary, setOrderSummary] = useState({});
  const [orderData, setOrderData] = useState({});
  const [barProps, setBarProps] = useState({ steps: [] });
  const [cartQtyList, setCartQtyList] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedPickupStore, setSelectedPickupStore] = useState(null);
  const [sendGA, setSendGA] = useState(true);
  const [addressList, setAddressList] = useState([]);
  const [noAddress, setNoAddress] = useState(false);

  /*Redux Start*/
  const dispatch = useDispatch();
  const email = useSelector(emailSelector);
  const delivery = useSelector(deliverySelector);
  const setDelivery = data => dispatch(setDeliveryAction(data));
  const clearBillingFormData = data => dispatch(clearBillingInfoAction(data));
  const clearShippingFormData = data => dispatch(clearShippingInfoAction(data));
  const clearContactFormData = data => dispatch(clearContactInfoAction(data));
  const setPickupStore = data => dispatch(setPickupStoreAction(data));
  /*Redux End*/
  useEffect(() => {
    getCountryFromMarket();
    if (totalAmount && cartQtyList && selectedDelivery) {
      if (selectedDelivery?.code === PickupInStoreCode && selectedPickupStore) {
        getOrderSummaryData(totalAmount, cartQtyList, selectedDelivery, selectedPickupStore).then();
      }
      if (selectedDelivery?.code !== PickupInStoreCode) {
        getOrderSummaryData(totalAmount, cartQtyList, selectedDelivery).then();
      }
    }
  }, [totalAmount, cartQtyList, selectedDelivery, selectedPickupStore]);
  const onCheckoutViewInit = async isInStore => {
    getGearsProgressBars(progressBar, selectedBar).then(value => {
      if (value) setBarProps(value);
    });
    const res = await getCart(lang);
    let { skuList, afterDiscountTotalPrice } = res.obj;
    skuList = skuList ? skuList : [];
    const cartSpuIds = [];
    const cartQtyList = skuList.map(x => ({
      skuId: x.skuId,
      qty: x.skuCount
    }));
    for (let skuItem of skuList) {
      if (!cartSpuIds.includes(skuItem.spuId)) {
        cartSpuIds.push(skuItem.spuId);
      }
    }
    setCartQtyList(cartQtyList);
    setTotalAmount(afterDiscountTotalPrice);
    await initDeliveryMethods(cartSpuIds, isInStore);
    const { obj } = await api.stock(null, {
      skuIds: cartQtyList.map(e => e.skuId)
    });
    const result = obj.map(it => ({
      ...it,
      value: `${it.countryName} - ${it.languageName}`,
      code: it.siteCotext,
      disabled: it.skuList.length === 0
    }));
    const current = result.find(it => new RegExp(`^${it.code}$`, "gi").test(lang));
    setCurrentMarket(current);
    webStorage.set(S_MARKET, current);
    setMarkets(result);
    if (isLoggedIn()) {
      await loadAddressList();
    }
    return {
      market: current
    };
  };
  const loadAddressList = async () => {
    let _addressList = await getAddressList(newAddressLabel.value);
    setNoAddress(_addressList.length === 0);
    setAddressList(_addressList);
  };
  const addAddress = async address => {
    const newAddressList = await getAddressList(newAddressLabel.value);
    const addedItem = newAddressList.find(x => addressList.every(y => x.value !== y.value));
    addedItem.address.firstName = address.firstName;
    addedItem.address.lastName = address.lastName;
    addedItem.isNew = true;
    setNoAddress(newAddressList.length === 0);
    setAddressList(newAddressList);
    return addedItem;
  };
  const updateAddress = async () => {
    const newAddressList = addressList.slice();
    const newAddr = newAddressList.find(x => x.isNew);
    if (newAddr) {
      delete newAddr.isNew;
    }
    setAddressList(newAddressList);
  };
  const removeAddress = address => {
    const index = addressList.findIndex(x => x === address);
    addressList.splice(index, 1);
    const newAddressList = addressList.slice();
    const newAddr = newAddressList.find(x => x.isNew);
    if (newAddr) {
      delete newAddr.isNew;
    }
    setAddressList(newAddressList);
  };
  const initDeliveryMethods = async (cartSpuIds, isInStore) => {
    const methods = await getDeliveryMethods(cartSpuIds);
    if (methods.length > 0) {
      let deliveryMethods = methods.reduce((result, e) => {
        const { name, deliveryMethodId, deliveryMethodCode, path, estimateDeliveryTime, cost, description } = e;
        if ((isInStore && deliveryMethodCode !== PickupInStoreCode) || (!isInStore && deliveryMethodCode !== InstantCode)) {
          result.push({
            label: name,
            value: deliveryMethodId.toString(),
            code: deliveryMethodCode,
            logo: path,
            deliveryTime: estimateDeliveryTime,
            formattedPrice: MathUtils.priceFormat(cost, lang),
            note: description
          });
        }
        return result;
      }, []);
      setDeliveryMethods(deliveryMethods);
      let selectedItem = deliveryMethods.find(e => e.code === delivery?.code);
      if (!selectedItem && deliveryMethods.length > 0) {
        selectedItem = deliveryMethods[0];
      }
      setSelectedDelivery(selectedItem);
      setDelivery({
        id: selectedItem.value,
        code: selectedItem.code,
        cost: selectedItem.cost
      });
      return selectedItem;
    } else {
      return null;
    }
  };
  const getOrderSummaryData = async (totalAmount, cartQtyList, deliveryMethod, pickupStore) => {
    setError(null);
    setOrderSummary(null);
    setOrderData(null);
    setHasError(false);
    if (deliveryMethod) {
      try {
        setLoadingSummary(true);
        const body = {
          deliveryId: deliveryMethod.value,
          skuQtyVoList: cartQtyList
        };
        if (!isEmptyObject(pickupStore)) {
          body.storeCode = pickupStore.code;
          body.deliveryStoreCode = pickupStore.code;
        }
        const [res, result] = await getGearsOrderSummary(totalAmount, body, summaryItem, inStore);
        const _orderSummary = {
          ...result
        };
        setOrderSummary(_orderSummary);
        setOrderData(res);
        if (sendGA && res && res.orderItems) {
          /** Measurements */
          let dataLayer = window.dataLayer || [];
          let products = [];
          res.orderItems.forEach(item => {
            let product = {
              name: item.spuName,
              // id: "product_sku",
              price: item.paymentAmt, // Product price
              quantity: item.qty // Product quantity
              // brand: "product_brand", // Product brand
              // category: "Level_1/Level_2/Level_3", // Product category (max. 5 levels)
              // variant: "product_variant"
            };
            products.push(product);
          });
          dataLayer.push({
            event: "checkout",
            step: 2,
            products: products
          });
        }
      } catch (ex) {
        const apiErrors = await getApiErrors();
        let error = apiErrors.find(e => {
          return e.code.value === ex?.code;
        });
        if (!error) {
          error = apiErrors.find(e => e.code.value === "DEFAULT");
        }
        if (error) {
          setError(error);
          setHasError(true);
        }
      } finally {
        setLoadingSummary(false);
        /** Measurements */
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "checkoutOption",
          option: deliveryMethod.value,
          step: 2
        });
      }
    }
  };
  const [showModal, setShowModal] = useState(false);
  const { emailLabel, emailMissingMessage, emailWarningMessage, phoneAreaLabel, phoneLabel, phoneMissingMessage, phoneWarningMessage, contactheadingType, contactheading } = billingFormLabels.fields;
  const contactInfo = {
    fields: {
      heading: {
        type: contactheadingType || {
          fields: { phrase: { value: "h3" } }
        },
        html: contactheading
      },
      emailLabel,
      emailMissingMessage,
      emailWarningMessage,
      phoneAreaLabel,
      phoneLabel,
      phoneMissingMessage,
      phoneWarningMessage
    }
  };
  const shippingInfoProps = {
    fields: shippingInfo.fields,
    addressList,
    loadAddressList,
    addAddress,
    updateAddress,
    removeAddress
  };
  const billingInfoProps = {
    fields: billingInfo.fields,
    addressList,
    loadAddressList,
    addAddress,
    updateAddress,
    removeAddress,
    noAddress
  };
  console.log("orderSummary", orderSummary);
  const deliveryInfo = {
    heading: deliveryheading,
    selectedOption: selectedDelivery,
    orderFetched: !isEmptyObject(orderData),
    isFree: orderData?.isFreeShipping === "1",
    freeText: freeText.value,
    onChange: async option => {
      setSelectedDelivery(option);
      setDelivery({
        id: option.value,
        code: option.code,
        cost: option.cost
      });
    },
    options: deliveryMethods,
    submit: {
      buttonText: submitButtonText.value,
      width: "auto",
      iconName: submiticon,
      isDisabled: hasError || loadingSummary
    }
  };
  const storeInfoProps = _.merge({}, storeInfo?.fields, {
    selectedOption: selectedPickupStore,
    onChange: async store => {
      setSelectedPickupStore(store);
    }
  });
  const checkoutDelivery = {
    lang: lang,
    page,
    userInfo: {
      email: {
        html: email && `<span>${emailTopBody?.value || ""} <a href="#">${email}</a></span>`
      },
      country: {
        html: currentMarket ? `<div class="label">${countryLabel.value} <span> ${currentMarket.value || currentMarket.regionName}</span></div>` : ""
      }
    },
    changeMarket: {
      text: changeMarketButtonText.value || "Change market",
      callback: function(e) {
        setShowModal(true);
      }
    },
    heading: {
      type: headingType || {
        fields: { phrase: { value: "h3" } }
      },
      html: headingBody
    },
    billingCheckbox: {
      label: billingCheckbox.value
    },
    market: currentMarket,
    shippingInfo: shippingInfoProps,
    billingInfo: billingInfoProps,
    contactInfo,
    deliveryInfo,
    storeInfo: storeInfoProps,
    orderSummary: orderSummary,
    barProps: barProps,
    errorMessage: error,
    onCheckoutViewInit: isInStore => onCheckoutViewInit(isInStore)
  };
  const modalProps = {
    heading: {
      type: modelHeadingType || {
        fields: { phrase: { value: "h1" } }
      },
      html: modelHeadingBody
    },
    body: modelBody.value,
    button: {
      buttonText: acceptButton?.fields.link.value.text,
      iconName: acceptButton?.fields.iconName
    },
    country: {
      placeholder: countryImput?.fields.placeholder.value || "Country",
      selectCode: currentMarket ? currentMarket.code : null,
      options: markets,
      enableFilter: true,
      warningMessage: countryImput?.fields.warningMessage.value || "It is mandatory to select a country"
    },
    link: {
      text: rejectLink?.fields.link.value.text,
      callback: evt => setShowModal(false)
    },
    open: showModal,
    disabled: false,
    onSubmitForm: data => {
      const newLang = data.country.code.toLowerCase();
      webStorage.set(S_LANG, newLang);
      clearBillingFormData();
      clearShippingFormData();
      clearContactFormData();
      setPickupStore(null);
      window.location.href = `${window.location.origin}/${newLang}/${params.sitecoreRoute}`;
    },
    onCloseClicked: () => {
      setShowModal(false);
    }
  };
  const errorProps = {
    showError: !!error,
    error: error,
    onClose: () => {
      setError(null);
    }
  };
  const getCountryFromMarket = async () => {
    const country = await getMarketCountry();
    setCurrentMarket(country);
  };
  return (
    <div datasourceid={rendering.dataSource}>
      <CheckoutDelivery {...checkoutDelivery} />
      <ChangeMarketModal {...modalProps} />
      <CheckoutErrorView {...errorProps} />
    </div>
  );
};
export default DeliveryPage;
